// Static content for ZT Health website. Sourced from the supplied document and ACH leadership/news pages.

export const IMAGES = {
  heroBuilding:
    "/hero-consult.jpg",
  abstractBlue:
    "https://static.prod-images.emergentagent.com/jobs/1400db1b-f73e-4e06-9ae2-29663d7e0913/images/333ff7d76b44be50bd2d57cafd3c3c3c7854a9dc2bb24f075cb0c6e2dc9943c3.png",
  facilityInterior:
    "https://static.prod-images.emergentagent.com/jobs/1400db1b-f73e-4e06-9ae2-29663d7e0913/images/025426653af5360f8eac5093c4e69dd161fa1a92eec166a2e8375e069c28122a.png",
  corporateMeeting:
    "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzc4MDg2ODU2fDA&ixlib=rb-4.1.0&q=85",
  medicalProfessional:
    "https://images.unsplash.com/photo-1666886573421-d19e546cfc4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwcHJvZmVzc2lvbmFscyUyMHdvcmtpbmd8ZW58MHx8fHwxNzc4MDg2ODU2fDA&ixlib=rb-4.1.0&q=85",
  hospitalExterior:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/e1mv5nur_PHOTO-2026-05-14-08-47-18.jpg",
  physicianPatient:
    "https://images.pexels.com/photos/7088526/pexels-photo-7088526.jpeg?w=1600&auto=compress&fit=crop",
  healthcareTeam:
    "https://images.pexels.com/photos/6129507/pexels-photo-6129507.jpeg?w=1600&auto=compress&fit=crop",
  altusTexasMap:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/3m1hv495_0226_ACH_TX_Map_single.png",
};

// Era imagery for the timeline (royalty-free Unsplash photos + uploaded brand photos)
export const TIMELINE_IMAGES = {
  // Uploaded brand photos
  y2003: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/pv5yijnl_homepage-timeline-2003.png",
  y2007: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/cywyfl2b_homepage-timeline-2007.webp",
  y2009: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/txb503q1_homepage-timeline-2009.webp",
  y2010: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/b3wl54vn_homepage-timeline-2010.webp",
  y2013: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/xq6dv6tm_homepage-timeline-2013.webp",
  y2014: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/o7k60p9l_homepage-timeline-2014.webp",
  y2015: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/xlr8l6th_homepage-timeline-2015.webp",
  y2018: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/453ky9t7_homepage-timeline-2018.webp",
  y2020: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/q6d3887k_homepage-timeline-2020.webp",
  y2021: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/n4coi93b_homepage-timeline-2021.webp",
  y2023: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/w4sq9gwh_homepage-timeline-2023-2.webp",
  y2024: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/d09323fb_homepage-timeline-2024.jpg",
  y2025: "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/dj02h5o5_homepage-timeline-2025.jpg",
  y2026: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1600&q=80&auto=format&fit=crop",
  // Stock fallbacks for years without a custom photo
  origin:
    "https://images.unsplash.com/photo-1551076805-e1869033e561?w=1200&q=80&auto=format&fit=crop",
  expansion:
    "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80&auto=format&fit=crop",
  emergency:
    "https://images.unsplash.com/photo-1587351177541-2e9f0a99ed2c?w=1200&q=80&auto=format&fit=crop",
  acquisition:
    "https://images.unsplash.com/photo-1638202993928-7267aad84c31?w=1200&q=80&auto=format&fit=crop",
  consolidation:
    "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=1200&q=80&auto=format&fit=crop",
  growth:
    "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=80&auto=format&fit=crop",
  modern:
    "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=1200&q=80&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Locations", to: "/locations" },
  { label: "Leadership", to: "/leadership" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const COMMITMENT_VALUES = [
  {
    title: "Employee-First Mindset",
    description:
      "We build a culture where every team member feels valued, supported, and empowered to succeed.",
    icon: "Users",
  },
  {
    title: "Operational Excellence",
    description:
      "We take ownership, solve problems, and build scalable systems that drive consistent results.",
    icon: "Target",
  },
  {
    title: "Service for All",
    description:
      "We serve every patient, teammate, and community member with respect, clarity, and care.",
    icon: "HeartHandshake",
  },
  {
    title: "Empathy Centered",
    description:
      "We lead with compassion by listening first and staying connected to the needs of others.",
    icon: "Heart",
  },
  {
    title: "Building Tomorrow",
    description:
      "We embrace innovation and long-term thinking to create sustainable growth and a stronger future.",
    icon: "Sparkles",
  },
];

export const OPERATING_MODEL = [
  {
    eyebrow: "Operating Model",
    title: "Operator-Led",
    description:
      "We build healthcare platforms by operating businesses, not simply owning or managing them.",
    icon: "Briefcase",
  },
  {
    eyebrow: "Execution",
    title: "Leadership",
    description:
      "Our leadership teams execute day-to-day decisions with a focus on improving clinical and business outcomes at every level.",
    icon: "Compass",
  },
  {
    eyebrow: "Platform Building",
    title: "Scalable Approach",
    description:
      "From staffing to supply chain, revenue cycle and patient experience, we make day-to-day decisions to build scalable healthcare businesses.",
    icon: "LayoutGrid",
  },
];

export const TIMELINE = [
  { year: "2003", title: "Inception of Altus Health", description: "Imaging, Sleep, and Surgery facilities open in Houston.", image: "y2003" },
  { year: "2007", title: "Beaumont Expansion", description: "Altus expands to Beaumont with Imaging, Sleep, and Surgery facilities.", image: "y2007" },
  { year: "2009", title: "Baytown Expansion", description: "Altus expands to Baytown with Imaging, Sleep, and Surgery facilities.", image: "y2009" },
  { year: "2010", title: "Houston Facility Expansion", description: "Continued growth of Altus operations in the Houston market.", image: "y2010" },
  { year: "2013", title: "Altus Emergency Centers Launch", description: "Developed Altus Emergency Centers in Baytown and Lumberton.", image: "y2013" },
  { year: "2014", title: "Lake Jackson & Baytown Hospital", description: "ER expansion in Lake Jackson; Baytown Surgery Center is converted into Altus Baytown Hospital.", image: "y2014" },
  { year: "2015", title: "Altus ER Holdco Acquisitions", description: "Acquired additional emergency rooms under Altus ER Holdco.", image: "y2015" },
  { year: "2018", title: "Neighbors ER Acquisition", description: "Acquired six Neighbors Emergency Center locations.", image: "y2018" },
  { year: "2020", title: "Community Healthcare Consolidation", description: "Hospitals, Altus ERs, Neighbor ERs, and IPUs consolidated into Altus Community Healthcare.", image: "y2020", fit: "contain" },
  { year: "2021", title: "Austin Market Entry", description: "Altus Community Healthcare acquired six Austin ERs and one urgent care facility.", image: "y2021" },
  { year: "2023", title: "Exceptional ER Acquisition", description: "Acquired 14 ERs from Exceptional Emergency Center; Altus Community Healthcare real estate exit.", image: "y2023" },
  { year: "2024", title: "Horizon Health Partners", description: "Acquired three specialty hospitals and one freestanding ER under Horizon Health Partners.", image: "y2024" },
  { year: "2025", title: "Express ER Acquisition", description: "Acquired four Express ER facilities, expanding Texas footprint.", image: "y2025" },
  { year: "2026", title: "Portfolio Optimization", description: "Sale of six Austin ERs and two Exceptional ERs as part of disciplined portfolio management.", image: "y2026" },
];

export const SERVICES = [
  {
    slug: "freestanding-er",
    eyebrow: "Service Vertical",
    title: "Freestanding Emergency Rooms",
    intro:
      "Convenient, community-based 24/7 emergency care designed to expand access and reduce wait times in markets that rely on accessible, high-quality acute services.",
    image: IMAGES.facilityInterior,
    accent: "navy",
    points: [
      { title: "Community-Based Access", description: "Brings 24/7 emergency services closer to patients in markets where traditional hospitals may be far, crowded, or limited.", icon: "MapPin" },
      { title: "Streamlined Throughput", description: "Right-sized facilities and streamlined operations reduce wait times and support efficient, well-coordinated clinical workflows.", icon: "Zap" },
      { title: "Modern Clinical Capability", description: "On-site imaging, lab, and emergency-trained physicians enable a full diagnostic and treatment pathway.", icon: "Stethoscope" },
      { title: "Operational Efficiency", description: "Disciplined cost management and scalable infrastructure support sustainable, long-term performance.", icon: "TrendingUp" },
    ],
  },
  {
    slug: "micro-hospitals",
    eyebrow: "Service Vertical",
    title: "Micro-Hospitals",
    intro:
      "Hospital-level care delivered in a smaller, more accessible footprint, combining emergency, inpatient, imaging, lab, and outpatient services in one connected campus.",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_corp-web-launch/artifacts/lbgf3n29_Lumberton-main-image.webp",
    accent: "gold",
    points: [
      { title: "Community-Based Hospital Access", description: "Provides hospital-level care closer to home in markets where patients may otherwise face long drives, crowded hospitals, or limited access points.", icon: "Building2" },
      { title: "Emergency Plus Inpatient Capability", description: "Combines 24/7 emergency care with short-stay inpatient beds, imaging, lab, and outpatient services, delivering a broader level of care than a traditional freestanding ER.", icon: "BedDouble" },
      { title: "Lower-Complexity, Higher-Convenience", description: "Offers an efficient, patient-friendly alternative to large hospital campuses with easier access, shorter navigation, and a more personal care environment.", icon: "Compass" },
      { title: "Scalable Care Delivery", description: "Smaller footprint than a full-service hospital allows healthcare systems to expand access in targeted communities more quickly and cost-effectively.", icon: "Layers" },
    ],
  },
  {
    slug: "physician-staffing",
    eyebrow: "Service Vertical",
    title: "Physician Staffing",
    intro:
      "A dependable physician staffing model built to support emergency departments, acute care settings, and hospital-based programs with reliable clinical coverage and consistent provider alignment.",
    image: IMAGES.medicalProfessional,
    accent: "sky",
    contactEmail: "khalid.siddiqui@altushealthsystem.com",
    contactSubject: "Physician Staffing Inquiry",
    points: [
      { title: "ER & Hospitalist Staffing Support", description: "Delivers ER physician staffing and hospitalist physician staffing solutions that help healthcare facilities maintain dependable coverage, reduce staffing disruptions, and strengthen care delivery across emergency and inpatient environments.", icon: "ShieldCheck" },
      { title: "Higher Care Consistency", description: "Aligns providers with clinical standards, patient experience expectations, documentation practices, and facility-level performance goals.", icon: "Activity" },
      { title: "Improved Patient Throughput", description: "Supports timely clinical decision-making and improved flow from arrival through discharge, admission, or transfer.", icon: "Users" },
      { title: "Scalable Provider Model", description: "Creates a flexible physician staffing infrastructure that can support new facilities, market expansion, volume changes, and evolving care delivery needs across the platform.", icon: "Layers" },
    ],
  },
];

export const FACILITY_PORTFOLIOS = [
  {
    portfolio: "Altus Community Healthcare",
    brands: [
      {
        name: "Altus Emergency Center",
        url: "https://altusemergency.com",
        facilities: [
          { name: "Lumberton Hospital", address1: "137 North LHS Drive", address2: "Lumberton, TX 77657", phone: "409-755-2273" },
          { name: "Lake Jackson", address1: "200 Oak Dr S", address2: "Lake Jackson, TX 77566", phone: "979-529-2000" },
          { name: "Waxahachie", address1: "1791 N. Highway 77", address2: "Waxahachie, TX 75165", phone: "469-383-7361" },
        ],
      },
      {
        name: "Exceptional Emergency Center",
        url: "https://eer24.com",
        facilities: [
          { name: "Amarillo @ Western", address1: "2105 S Western St", address2: "Amarillo, TX 79109", phone: "806-353-3200" },
          { name: "Beaumont", address1: "4755 Eastex Fwy", address2: "Beaumont, TX 77706", phone: "409-924-0055" },
          { name: "Lubbock", address1: "4337 50th St", address2: "Lubbock, TX 79413", phone: "806-701-5050" },
          { name: "Amarillo Coulter & Hillside", address1: "5800 S Coulter St", address2: "Amarillo, TX 79119", phone: "806-398-7744" },
          { name: "Orange", address1: "1321 N 16th St", address2: "Orange, TX 77630", phone: "409-670-9898" },
          { name: "Tyler", address1: "2222 East Southeast Loop 323", address2: "Tyler, TX 75701", phone: "903-707-8140" },
          { name: "Port Arthur", address1: "3330 FM 365", address2: "Port Arthur, TX 77642", phone: "409-722-9554" },
          { name: "Fort Worth @ Eastchase", address1: "1251 Eastchase Parkway", address2: "Fort Worth, TX 76120", phone: "817-566-0285" },
        ],
      },
      {
        name: "Neighbors Regional Hospital",
        url: "https://nec24.com/locations/livingston",
        facilities: [
          { name: "Amarillo", address1: "2101 S Coulter St", address2: "Amarillo, TX 79106", phone: "806-350-7744" },
          { name: "Livingston", address1: "111 Emergency Road", address2: "Livingston, TX 77351", phone: "936-327-7000" },
        ],
      },
      {
        name: "Neighbors Emergency Center",
        url: "https://nec24.com",
        facilities: [
          { name: "Baytown", address1: "6051 Garth Rd", address2: "Baytown, TX 77521", phone: "832-695-2020" },
          { name: "Porter", address1: "22678 Hwy. 59", address2: "Porter, TX 77365", phone: "281-354-4654" },
          { name: "Crosby", address1: "14120 FM 2100", address2: "Crosby, TX 77532", phone: "281-328-7770" },
          { name: "Pearland", address1: "11130 Broadway St", address2: "Pearland, TX 77584", phone: "713-436-9600" },
          { name: "Kingwood", address1: "1120 Kingwood Dr", address2: "Kingwood, TX 77339", phone: "281-358-8488" },
          { name: "Pasadena", address1: "7215 Fairmont Pkwy", address2: "Pasadena, TX 77505", phone: "281-487-0339" },
        ],
      },
    ],
  },
  {
    portfolio: "Horizon Health Partners",
    brands: [
      {
        name: "STAT Specialty Hospital",
        url: "https://statspecialtyhospital.com",
        facilities: [
          { name: "Laredo North", address1: "2502 NE Bob Bullock Lp", address2: "Laredo, TX 78045" },
          { name: "Del Rio", address1: "2600 Veterans Blvd", address2: "Del Rio, TX 78840" },
          { name: "Eagle Pass", address1: "2114 N Veterans Blvd", address2: "Eagle Pass, TX 78852" },
          { name: "South Laredo", address1: "1023 Bob Bullock Lp", address2: "Laredo, TX 78043" },
        ],
      },
    ],
  },
  {
    portfolio: "Vista Health Partners",
    brands: [
      {
        name: "Express ER",
        url: "https://expressercare.com",
        facilities: [
          { name: "Abilene", address1: "4157 Buffalo Gap Rd", address2: "Abilene, TX 79605", phone: "325-603-3400" },
          { name: "Waco", address1: "1411 N. Valley Mills Dr", address2: "Waco, TX 76710", phone: "254-294-6500" },
          { name: "Harker Heights", address1: "980 Knight's Way Bldg 1, Ste. 100", address2: "Harker Heights, TX 76548", phone: "254-781-5010" },
          { name: "Temple", address1: "1551 W Central Ave", address2: "Temple, TX 76504", phone: "254-435-5900" },
        ],
      },
    ],
  },
];


export const OFFICES = [
  {
    city: "Houston",
    address1: "1535 West Loop S, Suite 450",
    address2: "Houston, TX 77027",
    phone: "713-627-2000",
    fax: "713-231-2131",
  },
  {
    city: "Los Angeles",
    address1: "2029 Century Park East, Suite 1130N",
    address2: "Los Angeles, CA 90067",
    phone: "323-352-0176",
  },
  {
    city: "New York",
    address1: "150 E 52nd St., 31st Floor",
    address2: "New York, NY 10022",
    phone: "212-644-4343",
    fax: "718-679-9797",
  },
  {
    city: "Las Vegas",
    address1: "8488 Rozita Lee Ave, Suite 415",
    address2: "Las Vegas, NV 89113",
    phone: "702-867-8929",
  },
  {
    city: "Newport",
    address1: "660 Newport Center Dr., Suite 610",
    address2: "Newport Beach, CA 92660",
    phone: "949-340-0299",
  },
];

// Texas facility pins matching the 4 ER brands.
// x,y are percentages of the SVG viewBox (0-100). Color matches brand.
export const TEXAS_PINS = [
  // Panhandle / North
  { id: "p1", x: 45, y: 8, group: "altus", label: "Amarillo" },
  { id: "p2", x: 50, y: 24, group: "altus", label: "Lubbock" },
  // Dallas/Ft Worth cluster
  { id: "p3", x: 65, y: 36, group: "altus", label: "Dallas" },
  { id: "p4", x: 67, y: 38, group: "altus", label: "Dallas Hospital" },
  { id: "p5", x: 70, y: 38, group: "altus", label: "Plano" },
  { id: "p6", x: 60, y: 40, group: "neighbors", label: "Ft Worth" },
  // Central Texas (Waco / Temple / Harker Heights)
  { id: "p7", x: 58, y: 50, group: "express", label: "Waco" },
  { id: "p8", x: 56, y: 56, group: "express", label: "Temple" },
  { id: "p9", x: 60, y: 55, group: "express", label: "Harker Heights" },
  // East Texas
  { id: "p10", x: 75, y: 50, group: "altus", label: "Tyler" },
  { id: "p11", x: 78, y: 52, group: "altus", label: "Longview" },
  // Houston cluster
  { id: "p12", x: 78, y: 70, group: "neighbors", label: "Houston" },
  { id: "p13", x: 80, y: 71, group: "altus", label: "Houston Hospital" },
  { id: "p14", x: 82, y: 73, group: "altus", label: "Baytown" },
  { id: "p15", x: 76, y: 74, group: "neighbors", label: "Lake Jackson" },
  // Austin / Central
  { id: "p16", x: 60, y: 68, group: "altus", label: "Austin" },
  { id: "p17", x: 58, y: 72, group: "altus", label: "San Marcos" },
  // San Antonio
  { id: "p18", x: 53, y: 76, group: "exceptional", label: "San Antonio" },
  // South Texas
  { id: "p19", x: 56, y: 88, group: "neighbors", label: "Corpus Christi" },
  { id: "p20", x: 50, y: 95, group: "exceptional", label: "Brownsville" },
  // West / Abilene
  { id: "p21", x: 45, y: 50, group: "express", label: "Abilene" },
];

// Facility logos provided by ZT Health (PNG, transparent backgrounds).
export const FACILITY_LOGOS = {
  necHorizontal:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/0ndd9efk_NEC-Logo_NEC-Horizontal-Full%20Color%20%283%29.png",
  necRegionalRed:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/28383ahp_NEC_Logo_Regional%20Hospital_Red%20%286%29.png",
  altusECBlack:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/pd0npycq_Altus%20EC_Logo_Black%20%282%29.png",
  altusLumberton:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/caip2t7t_Altus_Lumberton_Logo_Full%20color%20%282%29.png",
  expressER:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/yz5ghdo6_ExpressER_logo_color%20%282%29.png",
  exceptionalEC:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/b75nvyrs_ExceptionalEmergency_Horizontal_Full%20color%20%282%29.png",
  statSpecialty:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/embfolgu_STAT_SSH-LOGO_color%20%284%29.png",
  statEmergency:
    "https://customer-assets.emergentagent.com/job_corp-web-launch/artifacts/bslo0epn_STAT%20Emergency%20Center%20Logo%20%281%29.png",
};

export const PORTFOLIO_GROUPS = [
  {
    name: "Altus Community Healthcare",
    color: "#24356E",
    description:
      "The flagship platform spanning emergency centers, hospitals, and integrated community-based care.",
    brands: [
      {
        name: "Neighbors Emergency Center & Neighbors Regional Hospital",
        website: "https://nec24.com/",
        logos: [
          { src: FACILITY_LOGOS.necHorizontal, alt: "Neighbors Emergency Center", href: "https://nec24.com/", shrink: true },
          { src: FACILITY_LOGOS.necRegionalRed, alt: "Neighbors Regional Hospital", href: "https://nec24.com/", boost: true },
        ],
      },
      {
        name: "Exceptional Emergency Center",
        website: "https://eer24.com/",
        logos: [
          { src: FACILITY_LOGOS.exceptionalEC, alt: "Exceptional Emergency Center", href: "https://eer24.com/" },
        ],
      },
      {
        name: "Altus Emergency Center & Altus Lumberton Hospital",
        website: "https://altusemergency.com/",
        logos: [
          { src: FACILITY_LOGOS.altusECBlack, alt: "Altus Emergency Center", href: "https://altusemergency.com/" },
          { src: FACILITY_LOGOS.altusLumberton, alt: "Altus Lumberton Hospital", href: "https://altusemergency.com/" },
        ],
      },
    ],
  },
  {
    name: "Horizon Health Partners",
    color: "#3397AC",
    description:
      "Specialty and acute platform expanding ZT Health's clinical depth across Texas markets.",
    brands: [
      {
        name: "STAT Specialty Hospital and STAT Emergency Room",
        website: "https://statspecialtyhospital.com/",
        logos: [
          { src: FACILITY_LOGOS.statSpecialty, alt: "STAT Specialty Hospital", href: "https://statspecialtyhospital.com/" },
          { src: FACILITY_LOGOS.statEmergency, alt: "STAT Emergency Center", href: "https://statspecialtyhospital.com/" },
        ],
      },
    ],
  },
  {
    name: "Vista Health Partners",
    color: "#5FB5C4",
    description:
      "A growing community-emergency platform anchored by the Express ER brand across underserved Texas markets.",
    brands: [
      {
        name: "Express ER",
        website: "https://expressercare.com/",
        logos: [
          { src: FACILITY_LOGOS.expressER, alt: "Express ER", href: "https://expressercare.com/" },
        ],
      },
    ],
  },
];

// Pin color groups for the portfolio map (4 ER brand families).
// Order here drives legend display order.
export const PIN_GROUPS = {
  "express": { color: "#16A34A", label: "Express Emergency Room" },
  "exceptional": { color: "#DC2626", label: "Exceptional Emergency Room" },
  "altus": { color: "#24356E", label: "Altus Emergency Center" },
  "neighbors": { color: "#0F172A", label: "Neighbors Emergency Center" },
};

export const LEADERS = [
  {
    name: "Taseer Badar",
    title: "Chairman & CEO, ZT Corporate",
    image: "https://ztcorporate.com/wp-content/uploads/ZT_Bio_TaseerBadar@2x.jpg",
    bio: "Taseer Badar is the Chairman and Chief Executive Officer of ZT Corporate, a Houston-based private investment firm focused on building durable businesses in essential industries. He founded ZT Corporate in 2003 as a retail brokerage serving the physician community, and over the past two decades has grown the firm into a diversified, multi-vertical platform spanning healthcare, automotive, and private capital. Under his leadership, ZT Corporate launched and scaled ZT Health, which today operates one of the largest privately held networks of micro-hospitals, freestanding emergency rooms, and specialty facilities in Texas. Taseer's investment thesis is grounded in operator-led execution, disciplined growth, and a commitment to expanding access to essential services in the communities ZT Corporate serves.",
  },
  {
    name: "Kraig Killough",
    title: "Executive Chairman & Vice Chairman, Officer of General Partner, ZT Corporate & Portfolio Companies",
    image: "https://altushc.com/wp-content/uploads/2026/05/ZT_Bio_KraigKillough-1@2x.jpg",
    bio: "Kraig Killough serves as Managing Director of Altus Community Healthcare and is a principal partner of ZT Corporate, overseeing all aspects of the company's growth and performance. Since joining ZT Corporate in 2002, he has spearheaded the formation of multiple healthcare organizations spanning acute and post-acute care, while serving as a primary investor and operating partner. As former Chief Operations Officer of Altus, he built the foundation of Altus Community Healthcare Management and scaled the organization from three employees to more than 1,000. Prior to ZT, he was a Vice President at Morgan Stanley, where he managed more than $30 million in client assets and served as a Compliance Principal. He holds a Bachelor's in Business Administration and Management from the University of Michigan.",
  },
  {
    name: "Farrukh Tariq",
    title: "President, ZT Health",
    image: "/farrukh-tariq.jpg",
    bio: "Farrukh Tariq serves as President of ZT Health, leading the strategic direction and operational performance of ZT Corporate's healthcare platform. Since joining ZT Corporate in 2014, he has held progressively senior roles across the firm, most recently as Group Chief Operating Officer overseeing portfolio operations spanning healthcare and automotive. He brings more than 20 years of experience across operations, business development, and finance, with deep expertise in team leadership, sell-side transactions, and scaling multi-site enterprises. Farrukh holds a degree in Economics and is known for pairing disciplined operating rigor with a hands-on, people-first approach to building durable healthcare businesses.",
  },
  {
    name: "Dr. Khalid Siddiqui",
    title: "Chief Medical Officer",
    image: "https://altushc.com/wp-content/uploads/2025/04/ach_Dr-Khalid-Siddiqui.png",
    bio: "Dr. Khalid Siddiqui brings more than 25 years of experience as an emergency medicine physician and healthcare executive, with leadership oversight of emergency medicine, ICU, and hospital programs across multiple markets. He previously served as Chair of Emergency Medicine at Aga Khan University Hospital and held senior leadership roles at TeamHealth and Winter Haven Hospital. His expertise spans strategic decision-making, patient-centered leadership, and disciplined financial management across complex clinical environments.",
  },
  {
    name: "Inam Khan",
    title: "SVP of Operations",
    image: "https://altushc.com/wp-content/uploads/2026/04/ach_Iman-Khan.png",
    bio: "Inam Khan is a seasoned healthcare operations executive with 18 years of experience leading hospital systems, freestanding emergency departments, and specialty care facilities. Having held both COO and CFO roles, he brings deep expertise in clinical operations, patient safety, regulatory compliance, and financial performance. A hands-on, people-centered leader, Inam has guided teams across U.S. and international healthcare systems and has supported the construction and launch of emergency centers, cancer hospitals, and global physician staffing initiatives. He holds an MBA in Accounting from the University of Houston.",
  },
  {
    name: "Kaleem Siddiqui",
    title: "Executive Vice President",
    image: "https://altushc.com/wp-content/uploads/2025/04/ach_Kaleem-Siddiqui.png",
    bio: "Kaleem Siddiqui brings more than 15 years of experience in healthcare supply chain management. During his tenure at Emerus Holdings, he was a key leader in the development and launch of more than 35 micro-hospitals across the country, guiding the organization through rapid expansion and historic supply shortages while establishing Emerus's centralized supply chain model as an industry benchmark. He later served as Head of Global Logistics, Inventory and Warehousing at Noble Drilling Services, the world's largest offshore drilling company.",
  },
  {
    name: "Lesley Small",
    title: "Director of Marketing",
    image: "/lesley-small.png",
    bio: "Lesley Small brings over 15 years of marketing and operations experience, with a background in leading brand strategy, digital marketing and growth initiatives for multi-location organizations. She is known for combining creative thinking with a strong operational mindset to develop practical strategies that strengthen customer and patient engagement, support local market growth and deliver measurable business results.",
  },
  {
    name: "Tadessa J. Williams",
    title: "VP, Human Resources",
    image: "https://altushc.wpenginepowered.com/wp-content/uploads/2023/10/leadership-tadessa.png",
    bio: "Tadessa Williams brings more than 15 years of experience in strategic human capital management. Since joining ZT Corporate in 2011, she has led HR initiatives across Altus Community Healthcare and the broader ZT portfolio, supporting more than 1,200 employees and aligning HR practices across 23 entities. Prior to ZT, she served as a regional HR consultant with TriNet and ADP TotalSource. She holds a BS in Marketing, an MS in Human Resources Management, and an MBA in Global Management, and is PHR-certified by the Society for Human Resource Management.",
  },
  {
    name: "Darleen Callahan",
    title: "VP of Revenue Cycle",
    image: "https://altushc.com/wp-content/uploads/2025/04/ach_Darleen-Callahan.png",
    bio: "Darleen Callahan brings more than two decades of experience in medical billing, contracting, and revenue cycle management across both provider and payer environments. Beginning her career in upstate New York, she advanced through progressive roles in healthcare operations, including provider relations at BCBS and leadership of an EPIC implementation team. She has also contributed to ICD-10 education initiatives and authored a Patient Financial Guide for a major hospital network.",
  },
];

export const NEWS = [
  {
    slug: "zt-corporate-enters-central-texas-express-er",
    date: "October 28, 2025",
    title: "ZT Corporate Enters New Central Texas Markets with Acquisition of Express ER Facilities",
    excerpt:
      "Addition of four Central Texas emergency centers marks continued execution of ZT Corporate's healthcare growth strategy across the state.",
    body: [
      "ZT Corporate, a private investment firm specializing in healthcare and automotive investments, announced the acquisition of four emergency care facilities operating under the Express ER brand. The facilities, located in Abilene, Waco, Harker Heights and Temple, will be integrated into ZT Corporate's healthcare portfolio, Altus Community Healthcare, marking a strategic expansion into new markets for the company.",
      "This acquisition increases ZT Corporate's total number of emergency care centers across Texas to 35, reinforcing its position as a key player in the state's evolving healthcare landscape. The four facilities will continue to operate under the Express ER brand.",
      "Taseer Badar, Chairman and Chief Executive Officer of ZT Corporate, said, \"This acquisition is another milestone in our aggressive growth strategy. We're not just entering new markets — we're shaping the future of emergency care across Texas.\"",
      "Muhammad Ali Chaudhry, MD MBA, Global Chief Executive Officer of Altus Community Healthcare, said, \"Express ER is a natural addition to our network, thanks to its strong community presence, well-established brand, and dedicated team.\"",
    ],
    source: "BusinessWire / ZT Corporate",
    url: "https://ztcorporate.com/news/zt-corporate-enters-new-central-texas-markets-with-acquisition-of-express-er-facilities/",
  },
  {
    slug: "zt-corporate-acquires-stat-specialty-hospital-south-texas",
    date: "November 12, 2024",
    title: "ZT Corporate Expands Portfolio, Acquires South Texas' STAT Specialty Hospital and Emergency Center",
    excerpt:
      "ZT Corporate expands its healthcare footprint into South Texas with the acquisition of STAT Specialty Hospital and a freestanding emergency center.",
    body: [
      "ZT Corporate announced the expansion of its healthcare portfolio into South Texas with the acquisition of STAT Specialty Hospital and its accompanying freestanding emergency center.",
      "The addition strengthens ZT Corporate's regional footprint and extends the company's ability to deliver specialty and emergency care to underserved communities across the state.",
      "The acquisition supports ZT Corporate's long-term strategy of building operator-led healthcare platforms that combine acute care access with disciplined operational and financial performance.",
    ],
    source: "ZT Corporate",
    url: "https://ztcorporate.com/news/zt-corporate-expands-portfolio-acquires-south-texas-stat-specialty-hospital-and-emergency-center/",
  },
  {
    slug: "zt-corporate-acquires-stat-specialty-hospital",
    date: "October 28, 2024",
    title: "ZT Corporate Acquires STAT Specialty Hospital Enhancing Regional Footprint",
    excerpt:
      "The acquisition of STAT Specialty Hospital strengthens ZT Corporate's specialty care presence and expands its healthcare investment platform.",
    body: [
      "ZT Corporate announced the acquisition of STAT Specialty Hospital, further enhancing the firm's regional healthcare footprint and specialty care capabilities.",
      "The transaction positions ZT Corporate to deliver a broader range of hospital-level and specialty services within its growing multi-vertical platform.",
      "The acquisition reflects ZT Corporate's disciplined approach to capital deployment and its focus on building durable healthcare businesses that improve community access.",
    ],
    source: "ZT Corporate",
    url: "https://ztcorporate.com/news/zt-corporate-acquires-stat-specialty-hospital-enhancing-regional-footprint/",
  },
  {
    slug: "zt-corporate-acquires-14-freestanding-ers-texas",
    date: "June 17, 2023",
    title: "Private Investment Group Acquires 14 Freestanding ERs in Texas",
    excerpt:
      "ZT Corporate acquires 14 freestanding emergency rooms from Exceptional Emergency Center, significantly expanding its Texas-wide healthcare portfolio.",
    body: [
      "ZT Corporate announced the acquisition of 14 freestanding emergency rooms across Texas from Exceptional Emergency Center, significantly expanding the firm's healthcare footprint.",
      "The transaction strengthens ZT Corporate's position as one of the largest privately held operators of emergency care facilities in the state, reinforcing its commitment to community-based access to essential services.",
      "The acquired facilities complement the firm's existing Altus Community Healthcare portfolio and further support ZT Corporate's long-term investment thesis in healthcare.",
    ],
    source: "ZT Corporate",
    url: "https://ztcorporate.com/news/private-investment-group-acquires-14-freestanding-ers-in-texas/",
  },
  {
    slug: "austin-emergency-center-renovated-reopening",
    date: "July 19, 2022",
    title: "Austin Emergency Center Opens Newly Renovated Freestanding Emergency Room Following Capital Infusion from ZT Corporate",
    excerpt:
      "A newly renovated Austin Emergency Center reopens following a capital infusion from ZT Corporate, expanding emergency care access in Central Texas.",
    body: [
      "Austin Emergency Center opened a newly renovated freestanding emergency room following a capital infusion from ZT Corporate, expanding access to high-quality emergency care in Central Texas.",
      "The reopening reflects ZT Corporate's continued investment in community-based healthcare and its strategy of supporting operator-led platforms with the capital and operational discipline needed to grow.",
      "The renovated facility offers patients modern amenities, upgraded clinical technology, and enhanced patient flow — reinforcing the firm's commitment to elevating the emergency care experience.",
    ],
    source: "ZT Corporate",
    url: "https://ztcorporate.com/news/austin-emergency-center-opens-newly-renovated-freestanding-emergency-room-following-capital-infusion-from-zt-corporate/",
  },
  {
    slug: "zt-corporate-acquires-6-neighbors-emergency-centers",
    date: "November 9, 2018",
    title: "Houston Co. Acquires 6 Neighbors Emergency Centers Out of Bankruptcy Court",
    excerpt:
      "Houston-based ZT Corporate acquires six Neighbors Emergency Center facilities out of bankruptcy court, expanding its Texas emergency care platform.",
    body: [
      "Houston-based ZT Corporate acquired six Neighbors Emergency Center facilities out of bankruptcy court, adding to the firm's growing network of freestanding emergency rooms across Texas.",
      "The acquisition preserved local emergency care access in the affected communities and positioned the facilities for renewed growth under ZT Corporate's operator-led investment model.",
      "The Neighbors locations were integrated into ZT Corporate's healthcare portfolio and continue to serve patients across the greater Houston area.",
    ],
    source: "ZT Corporate",
    url: "https://ztcorporate.com/news/houston-co-acquires-6-neighbors-emergency-centers-out-of-bankruptcy-court/",
  },
];

export const STATS = [
  { value: "27", label: "Texas Facilities" },
  { value: "21", label: "Freestanding ERs" },
  { value: "6", label: "Micro-Hospitals" },
  { value: "23", label: "Years of Operating Experience" },
];
